export const en = {
  copyRightHtml: '<span>&copy; %d 5 Dynamics<sup>&reg;</sup>, LLC</span><span>All Rights Reserved.</span>',
  copyRightText:
    'Any unauthorized copying, alteration, distribution, transmission, performance, display, or other use of this material is prohibited.',
  privacyPolicy: 'Privacy Policy',
  terms: 'Terms of Service',
}

export const es = en
